import classNames from "classnames";
import React from "react";

import { IFormSubmitButton } from "../models/formFields";
import { showValidationErrors } from "./hooks/formUtils";

export const FormSubmit = <FieldName extends string = string>(
    props: IFormSubmitButton<FieldName>,
): React.ReactNode => {
    const {
        hidden = false,
        type = "submit",
        value = "Submit",
        className = "button button--primary-congress-blue",
        id,
        inputRef,
        name,
        disabled,
        onMouseEnter,
        onMouseLeave,
        onSubmit,
    } = props;

    const inputProps = {
        id,
        ref: inputRef,
        name,
        type,
        className,
        value: value === null ? "" : value,
        disabled,
        onMouseEnter,
        onMouseLeave,
        onSubmit,
    };

    const classes = classNames({
        "form__field": true,
        "form__field--submit": true,
        "form__field--hidden": hidden,
        "form__field--has-errors": showValidationErrors(props),
    });

    return (
        <div className={classes}>
            <input {...inputProps} />
        </div>
    );
};
